import * as types from "./types";

export const tablet = {
  namespaced: true,

  state: {
    modal: false
  },
  getters: {
  },
  mutations: {
    setModal(state, flag) {
      state.modal = flag;
    }
  },
  actions: {
    [types.SET_MODAL]({ commit }, flag) {
      commit("setModal", flag);
    }
  }
};
